import {
  getStatus,
  getIconType,
  getImportance,
  getSolvability,
} from '../../constants/seoMappings';

/**
 * Generates message for mobile viewport section when no data
 * @param {Object} data - The mobile viewport data object
 * @returns {string|null} - Message for empty state or null if data exists
 */
const generateMessage = (data) => {
  if (!data || (data?.isPresent === undefined && data?.contentIsSizedToViewport === undefined)) {
    return 'No viewport was detected';
  }
  return null;
};

/**
 * Transforms the mobile_viewport criteria from WooRank API response
 * @param {Object} mobileViewportCriteria - The mobile_viewport criteria object from the API
 * @returns {Object} - Transformed mobile viewport data for React components
 */
export const transformMobileViewport = (mobileViewportCriteria) => {
  // Handle missing criteria - use 'neutral' status (maps to 'info' icon)
  if (!mobileViewportCriteria) {
    return {
      status: getStatus('neutral'),
      iconType: getIconType('neutral'),
      importance: { level: 0, text: '' },
      solvability: { level: 0, text: '' },
      isEmpty: true,
      message: 'No viewport was detected',
      data: null,
    };
  }

  const data = mobileViewportCriteria?.data || {};
  const wooRankStatus = mobileViewportCriteria?.status || 'neutral';
  const importance = mobileViewportCriteria?.importance || 0;
  const solvability = mobileViewportCriteria?.solvability || 0;

  // API returns booleans (not integers like old app expected)
  const isPresent = data?.isPresent ?? false;
  const isValid = data?.isValid ?? false;
  const contentIsSizedToViewport = data?.contentIsSizedToViewport ?? false;

  const isEmpty = data?.isPresent === undefined && data?.contentIsSizedToViewport === undefined;

  return {
    status: getStatus(wooRankStatus),
    iconType: getIconType(wooRankStatus),
    importance: getImportance(importance),
    solvability: getSolvability(solvability),
    isEmpty,
    message: generateMessage(data),
    data: isEmpty ? null : {
      isPresent,
      isValid,
      contentIsSizedToViewport,
      // Pre-computed display states for easier rendering
      viewportStatus: {
        isConfigured: isPresent,
        message: isPresent 
          ? 'Great, a configured viewport is present.' 
          : 'A viewport is not configured',
      },
      contentStatus: {
        isSized: contentIsSizedToViewport,
        message: contentIsSizedToViewport
          ? 'The content fits within the specified viewport size.'
          : 'The content does not fit within the specified viewport size.',
      },
    },
  };
};

export default transformMobileViewport;

